import { CommandHandler } from './types/command-handler-types';

export class PrepareContentForFinalizationCommandHandler extends CommandHandler<
	void,
	{ success: boolean }
> {
	listen(): Promise<{ success: boolean }> {
		return new Promise<{ success: boolean; content: any }>(async (resolve) => {
			try {
				const document = await this.properties.forceDraftSync?.();
				resolve({ success: true, content: document });
			} catch {
				resolve({ success: false, content: undefined });
			}
		});
	}
}
